import { defineTokens } from '@chakra-ui/react';

export const GRADIENTS = defineTokens({
  gradients: {
    primary: {
      value:
        'linear-gradient(90deg, rgba(9, 192, 206, 0.15) 0%, rgba(98, 122, 230, 0.15) 42.96%, rgba(161, 116, 235, 0.15) 100%)',
    },
    ai: {
      value: 'linear-gradient(90.2deg, #04C3CC -0.81%, #527BE4 40.47%, #A373EB 100%);',
    },
  },
});
